import { IToolbarLopActionTypes } from "../../action-types/common/IToolbarLopActions";
import { IToolbarLopReducer } from "../../reducer-model/common/IToolbarLopReducer";

const iniState: IToolbarLopReducer = {
    filter: {
        id_he: 0,
        id_khoa: 0,
        khoa_hoc: 0,
        id_chuyen_nganh: 0,
        id_lop: 0,
        sinh_vien_search: undefined,
    }
};
export const toolbarLopReducer = (state = iniState, action: IToolbarLopActionTypes): IToolbarLopReducer => {
    switch (action.type) {
        case "TOOBAR_LOP_CHANGE_FILTER":
            return {
                ...state,
                filter: action.payload
            };
        default:
            return state;
    }
}